import { render, staticRenderFns } from "./psuBzjReturnForm.vue?vue&type=template&id=4e246cda&scoped=true"
import script from "./psuBzjReturnForm.vue?vue&type=script&lang=js"
export * from "./psuBzjReturnForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e246cda",
  null
  
)

export default component.exports